import React from 'react';
import { WebUiInput } from 'src/modules/web-ui/components/input';
import { WebUiSelect } from 'src/modules/web-ui/components/select';

import { WebUiButton } from '../../../components/button';
import { type StaticLease } from './types';

export default function StaticLeasesSection({
  readonly,
  leases,
  newLease,
  setNewLease,
  vlanOptions,
  portOptions,
  onAddLease,
  onRemoveLease,
}: {
  readonly: boolean;
  leases: StaticLease[];
  newLease: {
    ip: string;
    type: 'Port based' | 'MAC';
    vlanId: number;
    port: number;
    mac: string;
    deploymentArchive: string;
    deploymentFilename: string;
    addVendorOption: boolean;
  };
  setNewLease: React.Dispatch<
    React.SetStateAction<{
      ip: string;
      type: 'Port based' | 'MAC';
      vlanId: number;
      port: number;
      mac: string;
      deploymentArchive: string;
      deploymentFilename: string;
      addVendorOption: boolean;
    }>
  >;
  vlanOptions: number[];
  portOptions: string[];
  onAddLease: () => void;
  onRemoveLease: (ip: string) => void;
}) {
  return (
    <div className="mt-4 w-full">
      <h4 className="font-bold">Static Leases</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>IP</th>
            <th>Type</th>
            <th>Value</th>
            <th>Options</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {leases.map((lease) => (
            <tr key={lease.ip} className="webui-table-row-content">
              <td>{lease.ip}</td>
              <td>{lease.type === 0 ? 'Port based' : 'MAC'}</td>
              <td>
                {lease.type === 0
                  ? `VLAN ${lease.value[0]} Port ${lease.value[1]}`
                  : String(lease.value[0] ?? '')}
              </td>
              <td>
                {lease.options?.length ? `Code ${lease.options[0].code}` : '-'}
              </td>
              <td>
                <WebUiButton
                  disabled={readonly}
                  onClick={() => onRemoveLease(lease.ip)}
                >
                  remove
                </WebUiButton>
              </td>
            </tr>
          ))}
          <tr className="webui-table-row-content">
            <td>
              <WebUiInput
                inputSize="sm"
                disabled={readonly}
                value={newLease.ip}
                onChange={(e) =>
                  setNewLease((p) => ({ ...p, ip: e.target.value }))
                }
              />
            </td>
            <td>
              <WebUiSelect
                inputSize="sm"
                options={[
                  { label: 'Port based', value: 'Port based' },
                  { label: 'MAC', value: 'MAC' },
                ]}
                disabled={readonly}
                value={newLease.type}
                onChange={(e) =>
                  setNewLease((p) => ({
                    ...p,
                    type: e.target.value as 'Port based' | 'MAC',
                  }))
                }
              />
            </td>
            <td>
              {newLease.type === 'MAC' ? (
                <WebUiInput
                  inputSize="sm"
                  disabled={readonly}
                  value={newLease.mac}
                  onChange={(e) =>
                    setNewLease((p) => ({ ...p, mac: e.target.value }))
                  }
                />
              ) : (
                <div>
                  VLAN{' '}
                  <WebUiSelect
                    inputSize="sm"
                    options={vlanOptions.map((vid) => ({
                      label: vid.toString(),
                      value: vid.toString(),
                    }))}
                    disabled={readonly}
                    value={newLease.vlanId}
                    onChange={(e) =>
                      setNewLease((p) => ({
                        ...p,
                        vlanId: Number(e.target.value),
                      }))
                    }
                  />{' '}
                  Port{' '}
                  <WebUiSelect
                    inputSize="sm"
                    options={portOptions.map((name) => ({
                      label: name,
                      value: name,
                    }))}
                    disabled={readonly}
                    value={newLease.port}
                    onChange={(e) =>
                      setNewLease((p) => ({
                        ...p,
                        port: Number(e.target.value),
                      }))
                    }
                  />
                </div>
              )}
            </td>
            <td>
              <label>
                <WebUiInput
                  inputSize="sm"
                  type="checkbox"
                  disabled={readonly}
                  checked={newLease.addVendorOption}
                  onChange={(e) =>
                    setNewLease((p) => ({
                      ...p,
                      addVendorOption: e.target.checked,
                    }))
                  }
                />{' '}
                Vendor opt
              </label>
            </td>
            <td>
              <WebUiButton disabled={readonly} onClick={onAddLease}>
                Add
              </WebUiButton>
            </td>
          </tr>
          {newLease.addVendorOption ? (
            <tr className="webui-table-row-content">
              <td colSpan={5}>
                Archive url{' '}
                <WebUiInput
                  inputSize="sm"
                  className="webui-input w-[280px]"
                  disabled={readonly}
                  value={newLease.deploymentArchive}
                  onChange={(e) =>
                    setNewLease((p) => ({
                      ...p,
                      deploymentArchive: e.target.value,
                    }))
                  }
                />{' '}
                Filename{' '}
                <WebUiInput
                  inputSize="sm"
                  className="webui-input w-[200px]"
                  disabled={readonly}
                  value={newLease.deploymentFilename}
                  onChange={(e) =>
                    setNewLease((p) => ({
                      ...p,
                      deploymentFilename: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
